import { render, staticRenderFns } from "./header.html?vue&type=template&id=011c36d6&scoped=true&external"
import script from "./header.js?vue&type=script&lang=js&external"
export * from "./header.js?vue&type=script&lang=js&external"
import style0 from "./header.scss?vue&type=style&index=0&id=011c36d6&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "011c36d6",
  null
  
)

export default component.exports